import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "product-listing" };
const _hoisted_2 = { class: "product-listing__search-section" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "product-listing__search-row" };
const _hoisted_5 = { class: "product-listing__search-container" };
const _hoisted_6 = { class: "product-listing__search-btn" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "product-listing__content-wrapper" };
const _hoisted_9 = { class: "container" };
const _hoisted_10 = { class: "product-listing__wrapper" };
const _hoisted_11 = { class: "sidebar-wrapper" };
const _hoisted_12 = { class: "product-listing__sidebar" };
const _hoisted_13 = { class: "product-listing__filter-group" };
const _hoisted_14 = { class: "product-listing__filter-header" };
const _hoisted_15 = { class: "product-listing__filter-items" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "product-listing__filter-group" };
const _hoisted_18 = { class: "product-listing__filter-header" };
const _hoisted_19 = { class: "product-listing__filter-items" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "product-listing__filter-group" };
const _hoisted_22 = { class: "product-listing__filter-header" };
const _hoisted_23 = { class: "product-listing__filter-items" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "product-listing__main" };
const _hoisted_26 = { class: "product-listing__mobile-filter-bar" };
const _hoisted_27 = {
    key: 0,
    class: "product-listing__filter-badge"
};
const _hoisted_28 = { class: "product-listing__grid" };
const _hoisted_29 = ["href"];
const _hoisted_30 = { class: "product-listing__card-left" };
const _hoisted_31 = { class: "product-listing__card-image-wrapper" };
const _hoisted_32 = ["src", "alt"];
const _hoisted_33 = { class: "product-listing__card-right" };
const _hoisted_34 = { class: "product-listing__card-category" };
const _hoisted_35 = { class: "product-listing__card-title" };
const _hoisted_36 = {
    key: 0,
    class: "product-listing__empty"
};
const _hoisted_37 = { class: "product-listing__mobile-drawer-content" };
const _hoisted_38 = { class: "product-listing__filter-group" };
const _hoisted_39 = { class: "product-listing__filter-header" };
const _hoisted_40 = { class: "product-listing__filter-items" };
const _hoisted_41 = ["onClick"];
const _hoisted_42 = { class: "product-listing__filter-group" };
const _hoisted_43 = { class: "product-listing__filter-header" };
const _hoisted_44 = { class: "product-listing__filter-items" };
const _hoisted_45 = ["onClick"];
const _hoisted_46 = { class: "product-listing__filter-group" };
const _hoisted_47 = { class: "product-listing__filter-header" };
const _hoisted_48 = { class: "product-listing__filter-items" };
const _hoisted_49 = ["onClick"];
const _hoisted_50 = { class: "product-listing__mobile-drawer-footer" };
import { ref, computed, onMounted } from 'vue';
import { useAssets } from '../../oil-finder/composables/useAssets';
import axios from 'axios';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductListing',
    setup(__props) {
        const { assetUrl } = useAssets();
        const products = ref([]);
        // All available filter options from API
        const categories = ref([]);
        const brands = ref([]);
        const viscosities = ref([]);
        const fetchProducts = async () => {
            try {
                const response = await axios.get('/api/oil-finder/products');
                products.value = response.data.data.products;
                categories.value = response.data.data.categories;
                brands.value = response.data.data.brands;
                viscosities.value = response.data.data.viscosities;
            }
            catch (e) {
                console.error('Cannot fetch products', e);
                products.value = [];
            }
        };
        onMounted(() => {
            fetchProducts();
        });
        // Filter state
        const selectedCategories = ref([]);
        const selectedBrands = ref([]);
        const selectedViscosities = ref([]);
        const searchQuery = ref('');
        const showMobileFilters = ref(false);
        // Get products that match current filters (excluding the filter type we're computing available options for)
        const getProductsForFilterContext = (excludeFilter) => {
            return products.value.filter(product => {
                const matchesCategory = excludeFilter === 'category' || selectedCategories.value.length === 0 || selectedCategories.value.includes(product.category);
                const matchesBrand = excludeFilter === 'brand' || selectedBrands.value.length === 0 || selectedBrands.value.includes(product.sub_brand);
                const matchesViscosity = excludeFilter === 'viscosity' || selectedViscosities.value.length === 0 || selectedViscosities.value.includes(product.viscosity);
                const matchesSearch = searchQuery.value === '' ||
                    product.title.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
                    product.category.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
                    product.code.toLowerCase().includes(searchQuery.value.toLowerCase());
                return matchesCategory && matchesBrand && matchesViscosity && matchesSearch;
            });
        };
        // Compute available options based on current filter selections
        const availableCategories = computed(() => {
            const contextProducts = getProductsForFilterContext('category');
            const availableSet = new Set(contextProducts.map(p => p.category));
            return categories.value.filter(cat => availableSet.has(cat));
        });
        const availableBrands = computed(() => {
            const contextProducts = getProductsForFilterContext('brand');
            const availableSet = new Set(contextProducts.map(p => p.sub_brand));
            return brands.value.filter(brand => availableSet.has(brand));
        });
        const availableViscosities = computed(() => {
            const contextProducts = getProductsForFilterContext('viscosity');
            const availableSet = new Set(contextProducts.map(p => p.viscosity));
            return viscosities.value.filter(viscosity => availableSet.has(viscosity));
        });
        // Computed filtered products
        const filteredProducts = computed(() => {
            if (!products.value)
                return [];
            return products.value.filter(product => {
                const matchesCategory = selectedCategories.value.length === 0 || selectedCategories.value.includes(product.category);
                const matchesBrand = selectedBrands.value.length === 0 || selectedBrands.value.includes(product.sub_brand);
                const matchesViscosity = selectedViscosities.value.length === 0 || selectedViscosities.value.includes(product.viscosity);
                const matchesSearch = searchQuery.value === '' ||
                    product.title.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
                    product.category.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
                    product.code.toLowerCase().includes(searchQuery.value.toLowerCase());
                return matchesCategory && matchesBrand && matchesViscosity && matchesSearch;
            });
        });
        // Active filters count
        const activeFiltersCount = computed(() => {
            return selectedCategories.value.length + selectedBrands.value.length + selectedViscosities.value.length;
        });
        // Methods
        const toggleCategory = (category) => {
            const index = selectedCategories.value.indexOf(category);
            if (index > -1) {
                selectedCategories.value.splice(index, 1);
            }
            else {
                selectedCategories.value.push(category);
            }
        };
        const toggleBrand = (brand) => {
            const index = selectedBrands.value.indexOf(brand);
            if (index > -1) {
                selectedBrands.value.splice(index, 1);
            }
            else {
                selectedBrands.value.push(brand);
            }
        };
        const toggleViscosity = (viscosity) => {
            const index = selectedViscosities.value.indexOf(viscosity);
            if (index > -1) {
                selectedViscosities.value.splice(index, 1);
            }
            else {
                selectedViscosities.value.push(viscosity);
            }
        };
        const clearCategories = () => {
            selectedCategories.value = [];
        };
        const clearBrands = () => {
            selectedBrands.value = [];
        };
        const clearViscosities = () => {
            selectedViscosities.value = [];
        };
        const toggleMobileFilters = () => {
            showMobileFilters.value = !showMobileFilters.value;
            // Prevent body scroll when drawer is open
            if (showMobileFilters.value) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = '';
            }
        };
        const clearAllFilters = () => {
            selectedCategories.value = [];
            selectedBrands.value = [];
            selectedViscosities.value = [];
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "product-listing__page-title" }, "Products", -1)),
                            _createElementVNode("div", _hoisted_5, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                    type: "text",
                                    placeholder: "What are you searching for?",
                                    class: "product-listing__search-input"
                                }, null, 512), [
                                    [_vModelText, searchQuery.value]
                                ]),
                                _createElementVNode("button", _hoisted_6, [
                                    _createElementVNode("img", {
                                        class: "product-listing__search-icon",
                                        src: _unref(assetUrl)('/images/trade-site/search-thick.svg'),
                                        alt: "Search"
                                    }, null, 8, _hoisted_7)
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("aside", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "product-listing__filter-title" }, "Category", -1)),
                                            (selectedCategories.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "product-listing__clear-group-btn",
                                                    onClick: clearCategories
                                                }, " Clear "))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCategories.value, (cat) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                    key: cat,
                                                    class: _normalizeClass(["product-listing__filter-pill", { 'product-listing__filter-pill--active': selectedCategories.value.includes(cat) }]),
                                                    onClick: ($event) => (toggleCategory(cat))
                                                }, _toDisplayString(cat), 11, _hoisted_16));
                                            }), 128))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "product-listing__filter-title" }, "Brand", -1)),
                                            (selectedBrands.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "product-listing__clear-group-btn",
                                                    onClick: clearBrands
                                                }, " Clear "))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableBrands.value, (brand) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                    key: brand,
                                                    class: _normalizeClass(["product-listing__filter-pill", { 'product-listing__filter-pill--active': selectedBrands.value.includes(brand) }]),
                                                    onClick: ($event) => (toggleBrand(brand))
                                                }, _toDisplayString(brand), 11, _hoisted_20));
                                            }), 128))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                            _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "product-listing__filter-title" }, "Viscosity", -1)),
                                            (selectedViscosities.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "product-listing__clear-group-btn",
                                                    onClick: clearViscosities
                                                }, " Clear "))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableViscosities.value, (viscosity) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                    key: viscosity,
                                                    class: _normalizeClass(["product-listing__filter-pill", { 'product-listing__filter-pill--active': selectedViscosities.value.includes(viscosity) }]),
                                                    onClick: ($event) => (toggleViscosity(viscosity))
                                                }, _toDisplayString(viscosity), 11, _hoisted_24));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("main", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("button", {
                                        class: "product-listing__mobile-filter-btn",
                                        onClick: toggleMobileFilters
                                    }, [
                                        _cache[6] || (_cache[6] = _createElementVNode("svg", {
                                            class: "product-listing__filter-icon",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 20 20",
                                            fill: "none"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M2 4h16M4 10h12M7 16h6",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round"
                                            })
                                        ], -1)),
                                        _cache[7] || (_cache[7] = _createTextVNode(" Filters ", -1)),
                                        (activeFiltersCount.value > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(activeFiltersCount.value), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (activeFiltersCount.value > 0)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "product-listing__clear-filters-btn",
                                            onClick: clearAllFilters
                                        }, " Clear all "))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: product.id,
                                            href: product.url,
                                            class: "product-listing__card"
                                        }, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("img", {
                                                        src: product.image,
                                                        alt: product.title,
                                                        class: "product-listing__card-image",
                                                        loading: "lazy"
                                                    }, null, 8, _hoisted_32)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_33, [
                                                _createElementVNode("p", _hoisted_34, _toDisplayString(product.category), 1),
                                                _createElementVNode("h3", _hoisted_35, _toDisplayString(product.code), 1),
                                                _createElementVNode("span", {
                                                    class: "product-listing__card-badge",
                                                    style: _normalizeStyle({ backgroundColor: product.hexcode })
                                                }, _toDisplayString(product.title), 5),
                                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "product-listing__card-btn" }, " View product ", -1))
                                            ])
                                        ], 8, _hoisted_29));
                                    }), 128))
                                ]),
                                (filteredProducts.value.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[9] || (_cache[9] = [
                                            _createTextVNode(" We couldn't find any products matching your search. Please ", -1),
                                            _createElementVNode("a", { href: "/contact" }, "contact", -1),
                                            _createTextVNode(" us for support and our team will be glad to assist you. ", -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createVNode(_Transition, { name: "mobile-filter" }, {
                        default: _withCtx(() => [
                            (showMobileFilters.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "product-listing__mobile-overlay",
                                    onClick: toggleMobileFilters
                                }, [
                                    _createElementVNode("div", {
                                        class: "product-listing__mobile-drawer",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                                    }, [
                                        _createElementVNode("div", { class: "product-listing__mobile-drawer-header" }, [
                                            _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "product-listing__mobile-drawer-title" }, "Filters", -1)),
                                            _createElementVNode("button", {
                                                class: "product-listing__mobile-drawer-close",
                                                onClick: toggleMobileFilters
                                            }, [...(_cache[10] || (_cache[10] = [
                                                    _createElementVNode("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            d: "M18 6L6 18M6 6l12 12",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            "stroke-linecap": "round"
                                                        })
                                                    ], -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _createElementVNode("div", _hoisted_39, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "product-listing__filter-title" }, "Category", -1)),
                                                    (selectedCategories.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "product-listing__clear-group-btn",
                                                            onClick: clearCategories
                                                        }, " Clear "))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_40, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCategories.value, (cat) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            key: cat,
                                                            class: _normalizeClass(["product-listing__filter-pill", { 'product-listing__filter-pill--active': selectedCategories.value.includes(cat) }]),
                                                            onClick: ($event) => (toggleCategory(cat))
                                                        }, _toDisplayString(cat), 11, _hoisted_41));
                                                    }), 128))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_42, [
                                                _createElementVNode("div", _hoisted_43, [
                                                    _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "product-listing__filter-title" }, "Brand", -1)),
                                                    (selectedBrands.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "product-listing__clear-group-btn",
                                                            onClick: clearBrands
                                                        }, " Clear "))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_44, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableBrands.value, (brand) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            key: brand,
                                                            class: _normalizeClass(["product-listing__filter-pill", { 'product-listing__filter-pill--active': selectedBrands.value.includes(brand) }]),
                                                            onClick: ($event) => (toggleBrand(brand))
                                                        }, _toDisplayString(brand), 11, _hoisted_45));
                                                    }), 128))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("div", _hoisted_47, [
                                                    _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "product-listing__filter-title" }, "Viscosity", -1)),
                                                    (selectedViscosities.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "product-listing__clear-group-btn",
                                                            onClick: clearViscosities
                                                        }, " Clear "))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_48, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableViscosities.value, (viscosity) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            key: viscosity,
                                                            class: _normalizeClass(["product-listing__filter-pill", { 'product-listing__filter-pill--active': selectedViscosities.value.includes(viscosity) }]),
                                                            onClick: ($event) => (toggleViscosity(viscosity))
                                                        }, _toDisplayString(viscosity), 11, _hoisted_49));
                                                    }), 128))
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("button", {
                                                class: "product-listing__mobile-drawer-clear",
                                                onClick: clearAllFilters
                                            }, " Clear all "),
                                            _createElementVNode("button", {
                                                class: "product-listing__mobile-drawer-apply",
                                                onClick: toggleMobileFilters
                                            }, " Show " + _toDisplayString(filteredProducts.value.length) + " products ", 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]))
            ]));
        };
    }
});
